import { render } from "./SearchPage.vue?vue&type=template&id=2e42d06b"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"

import "./SearchPage.vue?vue&type=style&index=0&id=2e42d06b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__